import * as React from 'react'
import { cn } from '@/utils/cn'

export interface NativeSelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  fullWidth?: boolean
}

const NativeSelect = React.forwardRef<HTMLSelectElement, NativeSelectProps>(
  ({ className, fullWidth = false, children, ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex h-10 rounded-[var(--radius)] border border-[hsl(var(--input))] bg-transparent px-3 py-2 text-sm',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[hsl(var(--ring))] focus-visible:ring-offset-2',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'transition-colors appearance-none',
        fullWidth && 'w-full',
        className
      )}
      {...props}
    >
      {children}
    </select>
  )
)

NativeSelect.displayName = 'NativeSelect'

export const Select = NativeSelect
export { NativeSelect }
